import { messageHandlerRegistry } from '@reducers/v2/messagesBus/handlerRegistry';
import { MachineMessageType } from '@reducers/v2/messagesBus/types';
import type { OnUpdatedMachineStatusSignalRResponse } from '@interfaces/machines';
import { TTL_FOR_MACHINE_STATUS_UPDATED } from '@reducers/machines/constants';
import { machineStatusUpdatedMessageHandler } from './machineStatusUpdatedMessageHandler';

messageHandlerRegistry.configure(MachineMessageType.MACHINE_STATUS_UPDATED, { ttl: TTL_FOR_MACHINE_STATUS_UPDATED });

messageHandlerRegistry.register(MachineMessageType.MACHINE_STATUS_UPDATED, ({ message }) =>
  machineStatusUpdatedMessageHandler(message.payload as OnUpdatedMachineStatusSignalRResponse)
);
